(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["at-code"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const copyButtons = document.querySelectorAll('.copy-text-button');
    
    copyButtons.forEach(button => {
      button.addEventListener('click', function() {
        const textToCopy = this.getAttribute('data-copy-text');
        
        navigator.clipboard.writeText(textToCopy).then(() => {
          // Visual feedback
          const originalHTML = this.innerHTML;
          this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
          this.style.color = '#4caf50';
          
          setTimeout(() => {
            this.innerHTML = originalHTML;
            this.style.color = '';
          }, 1500);
        }).catch(err => {
          console.error('Failed to copy text:', err);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
